const messages = {
    availPoints: "Puntos disponibles",
    awaitingPoints: "Puntos pendientes",
  board: {
    title: "Panel de control",
    title2: "Animación de rendimiento {year}",
    headline1: "Sus promociones y puntos de un vistazo",
    headline2: "Gane puntos con la compra de sus neumáticos.",
    pointsBalanceToDate: "SALDO DE PUNTOS A LA FECHA",
    availPoints: "Puntos disponibles",
    awaitingPoints: "Puntos pendientes",
    yourRealisation: "SUS LOGROS",
    yourEngagement: "Su compromiso anual: <b>{tyres} neumáticos</b>",
    yourPoints: "SUS PUNTOS",
    yourRetailPurchase: "SUS COMPRAS AL POR MENOR",
    yourRetailPurchaseCCS: "SUS VENTAS AL POR MENOR",
    pointsByPurchase: "puntos generados por sus compras",
    pointsByBoosters: "puntos generados por los boosters",
    pointsByBSPurchase: "Puntos generados por sus compras de Bridgestone",
    pointsByBSPurchaseCCS:
      "Puntos generados por sus ventas de neumáticos Bridgestone",
    remaining: "Neumáticos restantes",
    yourGoal: "Avance en el objetivo",
    unit: "neumáticos",
    buttons: {
      learnMore: "Más información sobre sus puntos",
      learnMoreAboutMechanism: "Más información sobre el mecanismo",
    },
    charts: {
      byBrand: "Por marca",
      bySize: "Por<br/>tamaño de llanta",
    },
    exploreResults: "Descubra sus resultados",
    tyreLimitInfo:
      "Se requiere un volumen mínimo de venta de 50 neumáticos Bridgestone y/o Firestone para cada período de campaña Booster.",
  },
  charts: {
    byBrand: "Por marca",
    bySize: "por tamaño de llanta",
  },

  dashboard: {
    dashboardTitle: "Tus beneficios",
    dashboardBox: {
      title: "Saldo de puntos",
      description: "Su total actual de puntos de marketing",
      availPoints: "Puntos disponibles",
      awaitingPoints: "Puntos pendientes",
      lastUpdate: "Última actualización",
      button: "Más información",
      points: "puntos",
    },
  },
  soldTyres: "NEUMÁTICOS VENDIDOS",
  receivedPoints: "PUNTOS OBTENIDOS",
  boosterCCS: {
    personalInfo: "Información personal",
    csNumberTitle: "Indique el o los números de cuenta participantes",
    tyresTitle: "Por favor, especifique el número de neumáticos vendidos",
    minTyresInfo:
      "Se requiere un mínimo de {tyres} neumáticos Bridgestone/Firestone. La compensación se aplica únicamente a los neumáticos Bridgestone.",
    tyresAmount: "No. de neumáticos",
    filesTitle: "Cargue su justificante de ventas",
    filesDescription:
      "Nota: solo se tendrán en cuenta las ventas que indiquen el tamaño de la llanta del neumático.",
    addAnotherFile: "Añadir otro documento",
    file: "Subir documento",
    formatInfo:
      "Formatos admitidos: xlsx, jpeg y pdf. Tamaño máximo del archivo: 8 MB",
    confrimationMessage:
      "<b>¡Gracias por su participación!</b> <br/>Su solicitud ha sido recibida y enviada a los equipos de Bridgestone para su validación.<br/>Recibirá un correo electrónico con los resultados de su participación en Booster CCS.<br/>¡Hasta pronto en Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Compartir puntos",
    forShare: "Puntos que va a compartir",
    title: "Título",
  },
  notFoundFile: "Ninguno seleccionado",
  chooseFile: "Elegir archivo",
};
export default {
  messages,
};
